const NAME = 'bulma-dropdowns';
const VERSION = '1.0';

const helpers = require('./helpers');

const initDropdowns = () => {
    console.log(NAME, 'initDropdowns');

    // Dropdowns

    var $dropdowns = helpers.getAll('.dropdown:not(.is-hoverable)');

    if ($dropdowns.length > 0) {
        $dropdowns.forEach(function ($el) {
            $el.addEventListener('click', function (event) {
                event.stopPropagation();
                $el.classList.toggle('is-active');
            });
        });

        document.addEventListener('click', function (event) {
            closeDropdowns();
        });
    }

    function closeDropdowns() {
        $dropdowns.forEach(function ($el) {
            $el.classList.remove('is-active');
        });
    }

    document.addEventListener('keydown', function (event) {
        var e = event || window.event;
        if (e.keyCode === 27) {
            closeDropdowns();
        }
    });
};

module.exports = {
    initDropdowns
}